<div class="payment-ledger-shell">
  <div class="container fw-b wrapper-content">
    <app-linker-route
      [headingName]="headingName"
      [linkerRouteItems]="linkerRouteItems"
    ></app-linker-route>
  </div>

  <section class="container ledger-table-section">
    <article class="ledger-table-card">
      <div class="table-header">
        <div>
          <p class="section-eyebrow">Transactions</p>
          <h2>Customer payment activity</h2>
        </div>
        <span class="badge-counter">{{ totalItems || 0 }} records</span>
      </div>

      <div class="table-responsive">
        <table class="table modern-table">
          <thead>
            <tr>
              <th scope="col">S No.</th>
              <th scope="col">Customer Name</th>
              <th scope="col">Order ID</th>
              <th scope="col">Date & Time</th>
              <th scope="col">Total Receive Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let item of paymentData
                  | paginate
                    : {
                        itemsPerPage: pageSize,
                        currentPage: currentPage,
                        totalItems: totalItems
                      };
                let i = index
              "
            >
              <td>{{ pageSize * (currentPage - 1) + i + 1 }}</td>
              <td class="customer-name" data-label="Customer Name">
                {{ item?.userDetails?.firstName }} {{ item?.userDetails?.lastName }}
              </td>
              <td class="order-id" data-label="Order ID">{{ item?.orderDetails?.orderId || '--' }}</td>
              <td data-label="Date & Time">{{ item?.createdAt | date : 'yyyy-MM-dd h:mm:ss a' }}</td>
              <td class="amount-cell amount-cell--positive" data-label="Total Receive Amount">
                {{
                  item?.orderAmount
                    ? getPrice(item?.orderAmount | currency : 'ZAR' : 'R')
                    : '--'
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <app-table-loader
        [isTable]="'TABLE'"
        [isLoading]="isLoading"
        [notFoundData]="notFoundData"
        [colspan]="5"
        [isWidth]="'55px'"
      >
      </app-table-loader>

      <div class="ledger-table-footer" *ngIf="totalItems > pageSize">
        <pagination-controls (pageChange)="pagination($event)"></pagination-controls>
      </div>
    </article>
  </section>
</div>